import { useState, useEffect } from 'react';
import { imageCache } from '../lib/imageCache';

export function useCachedImage(url: string | undefined): string | undefined {
  const [cachedUrl, setCachedUrl] = useState<string | undefined>(() => {
    if (!url) return undefined;

    // Always return the URL immediately
    // Let the browser's HTTP cache handle it via the <img> tag
    // No need to wait for preload or create Image objects
    return url;
  });

  useEffect(() => {
    if (!url) {
      setCachedUrl(undefined);
      return;
    }

    // Always set the URL - browser will use HTTP cache automatically
    setCachedUrl(url);
  }, [url]);

  return cachedUrl;
}

export function usePreloadImages(urls: (string | undefined)[]): void {
  useEffect(() => {
    const validUrls = urls.filter((url): url is string => !!url);
    if (validUrls.length === 0) return;

    imageCache.preloadMultiple(validUrls);
  }, [urls.join(',')]);
}
